import './css/styles.scss';


import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

const FancyInit = function () {
    const galleries = document.querySelectorAll('.femp-gallery-block .wp-block-gallery');

    if (!galleries.length) return;

    galleries.forEach((gallery, index) => {
        const groupName = `femp-gallery-${index}`;

        const links = gallery.querySelectorAll(
            'a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"], a[href$=".webp"]'
        );

        links.forEach((link) => {
            link.setAttribute('data-fancybox', groupName);

            const figcaption = link.closest('figure')?.querySelector('figcaption');
            if (figcaption) {
                link.setAttribute('data-caption', figcaption.textContent);
            }
        });
    });

    Fancybox.bind('[data-fancybox]', {
        hideScrollbar: false,
        dragToClose: false,
        closeButton: true,
        Toolbar: false,
        Image: {
            zoom: false,
            click: 'close',
            wheel: 'close',
        },
        showClass: 'fancybox-zoomIn',
        hideClass: 'fancybox-zoomOut',
    });
};

document.addEventListener('DOMContentLoaded', FancyInit);


// on dom ready
// Make sure to call the function -.-'
document.addEventListener('DOMContentLoaded', () => {
	FancyInit();
});

